import { inject, makeStateKey, TransferState } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PropertyService } from '../services/property.service';
import { of, tap } from 'rxjs';

export const propertyResolver: ResolveFn<any> = (route) => {
  const id = route.paramMap.get('id')!;
  const transferState = inject(TransferState);
  const propertyService = inject(PropertyService);
  
  // Create a unique key for this specific property
  const PROPERTY_KEY = makeStateKey<any>(`property-${id}`);

  // If the data is already in the state (on the client), use it
  if (transferState.hasKey(PROPERTY_KEY)) {
    const data = transferState.get(PROPERTY_KEY, null);
    return of(data);
  }

  // Otherwise, fetch it (on the server) and save it to the state
  return propertyService.getPropertyById(id).pipe(
    tap(data => {
      transferState.set(PROPERTY_KEY, data);
    })
  );
};